<template>
  <div data-qa="myprofileaddressproof-div-ix2ziej">
    <v-row
      no-gutters
      class="pt-2 pl-3"
      order-xs-3
      order-sm-3
       data-qa="myprofileaddressproof-row-fcej1k">
      <v-card width="414" data-qa="myprofileaddressproof-card-7xtfdjc">
        <v-card-text data-qa="myprofileaddressproof-card-text-11atmr">
          <v-row class="pl-4 pb-4 pr-8" data-qa="myprofileaddressproof-row-k69frj">
            <font :color="darkColor" class="text-h6 font-weight-light">{{ title }}</font>
            <v-spacer data-qa="myprofileaddressproof-spacer-b6333h"  />
            <v-icon
            @click="emitOnExitIconClick"
            :color="darkColor"
            name="deleteIcon"
             data-qa="myprofileaddressproof-icon-vjveo">mdi-close</v-icon
            >
          </v-row>

        <v-layout wrap data-qa="myprofileaddressproof-layout-1epjqu">
          <v-flex sm12 xs12 md12 lg12 xl12 class="pb-3 pl-1 pt-4" data-qa="myprofileaddressproof-flex-5msifc">
            <font class="body-2 font-weight-regular">{{ documentName }}</font>
          </v-flex>
          <v-flex
            v-if="enablePdfViewer"
            sm12
            xs12
            md12
            lg12
            xl12
            class="text-right"
             data-qa="myprofileaddressproof-flex-99gy38">
            <v-btn
              @click="emitOnPdfPreviewClick"
              :color="secondaryColor"
              class="text-none py-2 px-4"
              small
              outlined
               data-qa="myprofileaddressproof-btn-tcn42h">preview</v-btn
            >
            </v-flex>
        </v-layout>
        <v-row
            v-if="showImagePreview"
            justify="center"
            no-gutters
         data-qa="myprofileaddressproof-row-ygey2g">
            <div data-qa="myprofileaddressproof-div-444ap">
            <v-avatar
                height="200"
                width="250"
                style="max-width: 250"
                tile
             data-qa="myprofileaddressproof-avatar-pb88i">
                <img data-qa="myprofileaddressproof-img-82m45t"  :src="document" alt="Customer Doc" />
            </v-avatar>
            </div>
        </v-row>
        </v-card-text>
      </v-card>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'MyProfileAddressProof',
  props: {
    addressDocType: String
  },
  data () {
    return {
      enablePdfViewer: false,
      showImagePreview: false,
      document: null,
      documentName: '',
      title: this.$t('myProfileAddressProof.' + this.addressDocType + '.title'),
      imageFileTypes: ['/PNG', '/JPEG', '/JPG']
    }
  },
  created () {
    const document = this.$store.getters['profileStore/profileData'].addressDoc[this.addressDocType]
    this.document = document.data
    this.documentName = document.file.name

    const type = document.file.type.toUpperCase()
    this.enablePdfViewer = type.includes('/PDF')

    if (this.imageFileTypes.find(e => type.includes(e))) this.showImagePreview = true
  },
  methods: {
    emitOnExitIconClick () {
      this.$emit('onMyProfileAddressProofExitIconClick')
    },
    emitOnPdfPreviewClick () {
      this.$emit('onMyProfileAddressPdfPreviewClick')
    }
  }
}
</script>
